import type { GamKeyValue } from '@schibsted-nmp/advertising-shared';

import { Api } from './Api/index.js';

export async function setTargetingOnSlotOrGlobal(
  options: setTargetingOnSlotOrGlobal.Options,
  ...abortSignals: ReadonlyArray<AbortSignal>
) {
  const targeting = options.targeting.filter(({ value }) => value.length > 0);

  if ('slot' in options) {
    for (const target of targeting) {
      options.slot.setTargeting(target.key, target.value);
    }
  } else {
    await Api(
      (googletag) => {
        for (const target of targeting) {
          googletag.pubads().setTargeting(target.key, target.value);
        }
      },
      ...abortSignals
    );
  }
}

export namespace setTargetingOnSlotOrGlobal {
  export type Options = { targeting: ReadonlyArray<GamKeyValue> } & (
    | { slot: googletag.Slot }
    | { global: true }
  );
}
